import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import InfoTip from "../common/InfoTip";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootCVR: {
      // iPad縦
      "@media (min-width: 1000px)": {
        width: "97.0%",
      },
      // iPad横
      "@media (min-width: 1150px)": {
        width: "97.8%",
      },
      // GWPC
      "@media (min-width: 1200px)": {
        width: "98.0%",
      },
      marginBottom: "10px",
    },
    firstRowCell: {
      width: "1%",
      padding: "6px 0px",
    },
    secondRowCell: {
      "@media (min-width: 1000px)": {
        width: "11.5%",
      },
      "@media (min-width: 1150px)": {
        width: "9.3%",
      },
      "@media (min-width: 1200px)": {
        width: "7.8%",
      },
      padding: "6px 3px",
      fontSize: "11px",
      fontWeight: "bold",
      wordBreak: "keep-all",
    },
    secondRowCellCVR: {
      "@media (min-width: 1000px)": {
        width: "10.5%",
      },
      "@media (min-width: 1150px)": {
        width: "9.2%",
      },
      "@media (min-width: 1200px)": {
        width: "7.8%",
      },
      padding: "6px 3px",
      fontSize: "11px",
      fontWeight: "bold",
      wordBreak: "keep-all",
    },
    infoTipCell: {
      padding: "0px 3px",
    },
    cell: {
      padding: "2px",
      fontSize: "9px",
    },
    col: {
      padding: "1px",
      backgroundColor: "#ececec",
      whiteSpace: "pre",
    },
    firstTargetColor: {
      color: "#0000FF",
      fontSize: "20px",
    },
    secondTargetColor: {
      color: "#00B050",
      fontSize: "20px",
    },
    infoTip: {
      marginLeft: "18px",
    },
  })
);

const TableContent: React.FC<{
  data: any;
  baseAxis: number;
  firstDate: string;
  holiday: string[];
  today: string;
}> = ({ data, baseAxis, firstDate, holiday, today }) => {
  const classes = useStyles();
  const dateList = React.useRef<string[]>([]);
  const holidayList = React.useRef<string[]>([]);
  let countItem = 1;
  if (data !== undefined) {
    countItem = data.length;
  }
  const adjustWidth = 86 / countItem + "%";

  const makeDateList = () => {
    const tempDateList = [];
    const tempHolidayList = [];
    const year = firstDate.slice(0, 4);
    const month = firstDate.slice(4, 6);
    const day = firstDate.slice(6, 8);
    const dateStr = `${year}/${month}/${day}`;
    const standardDate = new Date(dateStr);
    const start = new Date(standardDate.setDate(standardDate.getDate() - 14));
    const end = new Date(standardDate.setDate(standardDate.getDate() + 28));
    for (let d = start; d <= end; d.setDate(d.getDate() + 1)) {
      let formatedDate = `${d.getFullYear()}/${
        d.getMonth() + 1
      }/${d.getDate()}`;
      const month = ("0" + (d.getMonth() + 1)).slice(-2);
      const date = ("0" + d.getDate()).slice(-2);
      let formatedHoliday = `${d.getFullYear()}${month}${date}`;
      tempDateList.push(formatedDate);
      tempHolidayList.push(formatedHoliday);
    }
    dateList.current = tempDateList;
    holidayList.current = tempHolidayList;
  };

  const checkHoliday = (index: number) => {
    if (baseAxis !== 1) return;
    const date = new Date(dateList.current[index]);
    if (date.getDay() === 0 || holiday.includes(holidayList.current[index])) {
      if (holiday.includes(holidayList.current[index])) {
      }
      return "red";
    } else if (date.getDay() === 6) {
      return "blue";
    }
  };

  const getWeekDay = (index: number) => {
    const week = ["日", "月", "火", "水", "木", "金", "土"];
    const date = new Date(dateList.current[index]);
    const weekDayNum = date.getDay();
    return week[weekDayNum];
  };

  const makeFutureTable = () => {
    const selectedDate = convertDate(firstDate);
    const twoWeekAgoDate = new Date(
      selectedDate.setDate(selectedDate.getDate() - 14)
    );
    const todayDate = convertDate(today);
    let dateDiff =
      (todayDate.getTime() - convertDate(firstDate).getTime()) / 86400000;
    if (todayDate > twoWeekAgoDate) {
      for (let d = 15 + dateDiff; d < 29; d++) {
        data[d].firstTenpoRealNumForTable = "-";
        data[d].secondMobakuRealNumForTable = "-";
        data[d].conversionRateForTable = "-";
      }
    }
  };

  const convertDate = (date: string) => {
    const year = date.slice(0, 4);
    const month = date.slice(4, 6);
    const day = date.slice(6, 8);
    const dateStr = `${year}/${month}/${day}`;
    return new Date(dateStr);
  };

  baseAxis === 1 && makeDateList();
  if (data) {
    baseAxis === 1 && data.length === 29 && makeFutureTable();
  }

  return (
    <>
      {data && (
        <Table className={classes.rootCVR} aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.firstRowCell}></TableCell>
              <TableCell
                className={classes.infoTipCell}
                style={{ width: "5%" }}
              >
                <div className={classes.infoTip}>
                  <InfoTip
                    iconType="info"
                    infoText="コンバージョンレート：CVR(%) ＝ 客数(人) ／ モバ空(人)&#13;&#10;※複数エリア選択時は合算&#13;&#10;※複数日付選択時は平均&#13;&#10;※複数エリア選択時かつ複数日付選択時は、エリア合算の平均"
                    placement="top"
                  />
                </div>
              </TableCell>
              {data.map((data: any, index: number) => (
                <TableCell
                  className={classes.col}
                  align="center"
                  key={index.toString()}
                  style={
                    baseAxis === 1 && data.date.length > 2
                      ? { color: checkHoliday(index), lineHeight: "1" }
                      : { lineHeight: "2" }
                  }
                >
                  {data.date}
                  <br />
                  {baseAxis === 1 &&
                    data.date.length > 2 &&
                    `(${getWeekDay(index)})`}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={classes.firstRowCell}>
                <span className={classes.firstTargetColor}>●</span>
              </TableCell>
              <TableCell className={classes.secondRowCellCVR} align="left">
                客数当年実数
                <br />
                （人）
              </TableCell>
              {data.map((data: any, index: string) => (
                <TableCell
                  className={classes.cell}
                  style={{ width: adjustWidth }}
                  align="center"
                  key={index.toString()}
                >
                  {data.firstTenpoRealNumForTable}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell className={classes.firstRowCell}>
                <span className={classes.secondTargetColor}>●</span>
              </TableCell>
              <TableCell className={classes.secondRowCellCVR} align="left">
                モバ空当年実数
                <br />
                （千人）
              </TableCell>
              {data.map((data: any, index: string) => (
                <TableCell
                  className={classes.cell}
                  style={{ width: adjustWidth }}
                  align="center"
                  key={index.toString()}
                >
                  {data.secondMobakuRealNumForTable}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell className={classes.firstRowCell}></TableCell>
              <TableCell className={classes.secondRowCellCVR} align="left">
                当年ＣＶＲ
                <br />
                (％)
              </TableCell>
              {data.map((data: any, index: string) => (
                <TableCell
                  className={classes.cell}
                  style={{ width: adjustWidth }}
                  align="center"
                  key={index.toString()}
                >
                  {isFinite(data?.conversionRateForTable)
                    ? data?.conversionRateForTable
                    : "-"}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default TableContent;
